import { FileUploadInterface } from './Profile';
import { ElementOptionsI } from './template';

export interface MetaDataAT {
  id: string;
  typeIndex: number;
  typeName: string;
  isActive: boolean;
  isDeleted: boolean;
  elementTypes: MetaDataET[];
}
export interface MetaDataET {
  id: string;
  elementTypeIndex: number;
  elementName: string;
  isActive: boolean;
  isDeleted: boolean;
  metadata: MetaDataElement[];
}
export interface MetaDataElement {
  elementValue: string;
  elementId: string;
  elementName: string;
  elementType: string;
  elementDateTime: string;
  creatorName: string;
  elementIndex: number;
  isActive: boolean;
  isDeleted: boolean;
  options: ElementOptionsI[];
  enableByDefault: boolean;
  validation: string;
  files: FileUploadInterface[];
  photos: FileUploadInterface[];
  templateElementId: string;
  readOnly: boolean;
  parentMetadataID: string[];
  metadatatype: string;
  parentId: string;
  isMandatory: boolean;
  span?: string;
  hasChild?: boolean;
  isMultiple?: boolean;
  dynamicTypeName?: string;
  dynamicTypeId?: string;
  selectMasterComponent: string;
  metadataFromParent?: string;
  // mode?: number;
}
export interface MetaDataOptions {
  optionId: string;
  optionIndex: number;
  optionName: string;
  optionDateTime: string;
  optionLinkId: string;
  optionLinkName: string;
  isActive: boolean;
  isSelected: boolean;
  isDeleted: boolean;
}

export interface PostFilteredItemDetailsTypes {
  title: string;
  currentTask:string;
  currentSubtask:string;
  status:string;
  PageNumber:number;
  PageSize:number;
  Previoustask: string;
  PreviousSubtask: string;
}


  export const initialPostFilteredItemDetails: PostFilteredItemDetailsTypes = {
    title: '',
    currentTask: '',
    currentSubtask: '',
    status: '',
    PageNumber:1,
    PageSize:5,
    Previoustask: '',
    PreviousSubtask: '',
  };

  
  type SubTask = {
  subTaskName: string;
};

type Task = {
  taskName: string;
  subTasks: SubTask[];
};

type Workflow = {
  tasks: Task[];
};

type ItemOrderReceiving = {
  receivingWorkflows: Workflow[];
};

type Order = {
  itemOrderReceiving: ItemOrderReceiving[];
};

type DataItem = {
  orders: Order[];
  current_task: string[];
  current_subtask: string[];
  previousTasks?: string;
  previousSubtasks?: string;
};

export const addPreviousTasksAndSubtasks = (data: DataItem[]): DataItem[] => {
  data.forEach(item => {
    const previousTasks: string[] = [];
    const previousSubtasks: string[] = [];

    item.orders.forEach(order => {
      order.itemOrderReceiving.forEach(receiving => {
        receiving.receivingWorkflows.forEach(workflow => {
          workflow.tasks.forEach(task => {
            if (!item.current_task.includes(task.taskName)) {
              previousTasks.push(task.taskName);
            }
            task.subTasks.forEach(subTask => {
              if (!item.current_subtask.includes(subTask.subTaskName)) {
                previousSubtasks.push(subTask.subTaskName);
              }
            });
          });
        });
      });
    });

    // Add previous tasks and subtasks to the item
    item.previousTasks = previousTasks.join(', ');
    item.previousSubtasks = previousSubtasks.join(', ');
  });

  return data;
}
